import React, { useCallback, useMemo, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import {
  createLogEntryPayload,
  withTrackProps,
} from "@dpdgroupuk/react-event-tracker";

import NestedSelect from "../../NestedSelect";
import SliderCard from "../../SliderCard";
import Button from "../../Button";
import palette from "../../styles/palette";
import RightDrawerModal from "../../RightDrawerModal";
import { StopMoveToTable } from "./components/StopMoveToTable";
import {
  MOVE_TO,
  MOVE,
  CONFIRM,
  PLACE_BEFORE_STOP,
} from "../../../constants/strings";
import { createStopOptions } from "../../../models/stop";
import { getSortedStops } from "../../../models/moveStops";
import { STOP_MOVE_TO_MODAL } from "../../../constants/analytics";

const useStyles = makeStyles((theme) => ({
  selectWrapper: {
    maxWidth: theme.typography.pxToRem(780),
  },
  divider: {
    height: theme.typography.pxToRem(40),
  },
}));

const StopMoveTo = ({
  open,
  onConfirm,
  onClose,
  onSelectStop,
  routeStops = [],
  selectedStops = [],
}) => {
  const classes = useStyles();
  const [selectedStop, setSelectedStop] = useState(null);

  const handleSaveClick = useCallback(() => {
    onConfirm(selectedStop);
  }, [onConfirm, selectedStop]);

  const routeStopOptions = useMemo(
    () => createStopOptions(getSortedStops(routeStops)),
    [routeStops]
  );

  const onStopSelect = useCallback(
    (stop) => {
      onSelectStop(stop);
      setSelectedStop(stop);
    },
    [onSelectStop]
  );

  return (
    <RightDrawerModal
      open={open}
      onClose={onClose}
      title={MOVE_TO.toUpperCase()}
      loadId={STOP_MOVE_TO_MODAL.LOAD}
      actions={
        <Button
          data-testid="save"
          variant="contained"
          disabled={selectedStop === null}
          opacityDisabled={0.38}
          bgColor={palette.modalButtons.blue}
          border={palette.btn.blueBorder}
          onClick={handleSaveClick}
        >
          {CONFIRM}
        </Button>
      }
    >
      <SliderCard title={MOVE}>
        <StopMoveToTable routeStops={selectedStops} />
        <Box className={classes.divider} />
        <Box className={classes.selectWrapper}>
          <NestedSelect
            value={selectedStop}
            onChange={onStopSelect}
            options={routeStopOptions}
            label={PLACE_BEFORE_STOP}
            data-testid={"place-before-stop-select"}
          />
        </Box>
      </SliderCard>
    </RightDrawerModal>
  );
};

export default withTrackProps({
  onConfirm: STOP_MOVE_TO_MODAL.CONFIRM,
  onClose: STOP_MOVE_TO_MODAL.SELECT_CLOSE,
  onSelectStop: (value) =>
    createLogEntryPayload(STOP_MOVE_TO_MODAL.SELECT_STOP, { value }),
})(StopMoveTo);
